import React from 'react';

import { COLOR_L5_PRIMARY_500 } from '../consts';

type Props = {
    fill?: string;
    width?: number;
    height?: number;
};
const CheckboxCheckedIcon = React.memo(function CheckboxCheckedIcon({
    fill = COLOR_L5_PRIMARY_500,
    width = 20,
    height = 20,
}: Props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10" cy="10" r="9.25" fill="white" stroke={fill} strokeWidth="1.5" />
            <circle cx="10" cy="10" r="6" fill={fill} />
        </svg>
    );
});

export default CheckboxCheckedIcon;
